import { styled, Typography } from '@material-ui/core'
import { ReactComponent as Alert } from 'shared/icons/alert.svg'

export const Text = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontWeight: 500,
}))

export const Wrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(1, 2),
  backgroundColor: theme.palette.error.light,
  borderRadius: 10,
  alignItems: 'center',
  alignSelf: 'flex-start',
  margin: theme.spacing(2, 0, 1.2),
}))

export const Icon = styled(Alert)(({ theme }) => ({
  color: theme.palette.error.main,
  marginRight: theme.spacing(1.2),
}))
